import { ThemeProvider } from "@mui/material";
import Routers from "./routes/routes";
import { theme } from "./theme";
import { AuthProvider, AuthContext } from "./providers/AuthProvider";
import { PlanProvider } from "./providers/PlanProvider";
import { UpgradeModalProvider } from "./providers/UpgradeModalProvider";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers";
import "moment/locale/pt-br";
import { ptBR } from "@mui/x-date-pickers/locales";
// import { MobileModal } from "./components/MobileModal";
import { ParallaxProvider } from 'react-scroll-parallax';
import { useContext } from "react";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./toast.css";
import "./theme/global.css";

const brazilianLocale =
  ptBR.components.MuiLocalizationProvider.defaultProps.localeText;

// Component to conditionally render PlanProvider only for companies
const ConditionalPlanProvider = ({ children }) => {
  const { user } = useContext(AuthContext);

  // Only render PlanProvider for companies
  if (user?.type === 'company') {
    return <PlanProvider>{children}</PlanProvider>;
  }

  // For talents, render children directly without PlanProvider
  return children;
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider
        dateAdapter={AdapterMoment}
        adapterLocale="pt-br"
        localeText={brazilianLocale}
      >
        <AuthProvider>
          <ConditionalPlanProvider>
            <UpgradeModalProvider>
              <ParallaxProvider>
                <Routers />
                <ToastContainer />
                {/* <MobileModal /> */}
              </ParallaxProvider>
            </UpgradeModalProvider>
          </ConditionalPlanProvider>
        </AuthProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
